const baseUrl = trimEndSlash(environment.settings["Integrations:SAG:BaseAddress"]);
const sagEnv = trimEndSlash(environment.settings["Integrations:SAG:Environment"]);

const envName = sagEnv ? `${sagEnv}/` : "";

export const appendEnvSuffix = (path: string) => trimEndSlash(`${trimEndSlash(path)}/${envName}`);

export const getSagApiUrl = (apiName: string, appendEnvName: boolean = true) => {
    const sagApiUrl = trimEndSlash(`${baseUrl}/${apiName}`);
    return appendEnvName ? appendEnvSuffix(sagApiUrl) : sagApiUrl;
};

export function trimEndSlash(s: string) {
    return s?.replace(/\/*$/, "");
}
